'use client';

import { useEffect, useState } from 'react';

import { useBrowserCheck, useLocalStorageState } from '@/shared/hooks';
import { STORAGE_KEY } from '@/shared/constants';

const useMobileSettingStartPage = () => {
  const { browser, isAndroid } = useBrowserCheck();
  const [isVisible, setIsVisible] = useState(false);
  const [extensionGuideClosed, setExtensionGuideClosed] = useLocalStorageState(
    STORAGE_KEY.EXTENSION_GUIDE,
    false
  );

  const onClose = () => {
    setIsVisible(false);
    if (typeof window !== 'undefined') {
      setExtensionGuideClosed(true);
    }
  };

  useEffect(() => {
    if (browser === undefined || extensionGuideClosed) return;
    if (browser === 'naver' && !isAndroid) return;

    setIsVisible(true);
  }, [browser, extensionGuideClosed, isAndroid]);

  return { isVisible, onClose, browser };
};

export default useMobileSettingStartPage;
